import jQuery from 'jquery';
import moment from "moment";

import 'moment/locale/ru'

moment.locale(document.querySelector('html')?.lang)

declare var globalThis: any;
globalThis.jQuery = jQuery;

export {
	jQuery as $,
	jQuery,
	moment
}